import React from "react";
import styled from "styled-components";
import { H3, Body } from "storybook-components/Typography";
import NewsletterModalBtn from "../NewsletterModalBtn";

import { ModuleOutlineBtn } from "storybook-components/Button";

import PardotForm from 'storybook-components/Pardot/PardotForm';
import Modal from 'storybook-components/Pardot/Modal';

const NewsletterCTA = styled.div`
  width: 100%;
  padding: 64px 36px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.colors.green5};
  border-radius: 10px;
  ${props => props.theme.media.tabletUp`
    flex-direction: row;
  `}
`;

const NewsletterCTAText = styled.div`
  text-align: left;
`;

const StyledNewsletterSubhead = styled(H3)`
  margin: 0 auto 1rem;
  max-width: 240px;
  text-align: center;
  color: ${({ theme }) => theme.colors.green2};
  ${props => props.theme.media.tabletUp`
    text-align: left;
    margin: 0;
  `}
`;
const StyledNewsletterMiniSubhead = styled(Body)`
  color: ${({ theme }) => theme.colors.green1};
  text-align: center;
  ${props => props.theme.media.tabletUp`
    text-align: left;
    margin: 0;
  `}
`;

const StyledNewsletterButton = styled(NewsletterModalBtn)`
  margin: auto;
  padding: 0 56px;
  background-color: ${({ theme }) => theme.colors.green2};
  ${props => props.theme.media.tabletUp`
    margin: auto 0;
  `}
`;

const StyledPardotButton = styled(ModuleOutlineBtn)`
  text-align: center;
  margin: 16px auto 0;
  background-color: ${({ theme }) => theme.colors.green2};
  padding: 0 18px;
  height: 50px;
  width: 170px;
  p {
    color: ${({ theme }) => theme.colors.green5};
    margin: 0;
  }
  &:hover {
    background-color: ${({ theme }) => theme.colors.green3};
  }
`;

export default () => {
  const modalRef = React.useRef();

  return <NewsletterCTA>
    <NewsletterCTAText>
      <StyledNewsletterSubhead>
        Get our weekly data newsletter
      </StyledNewsletterSubhead>
      <StyledNewsletterMiniSubhead>
        Work-related distractions for data enthusiasts.
      </StyledNewsletterMiniSubhead>
    </NewsletterCTAText>

    
    {/* <StyledNewsletterButton buttonTxt="Sign up" /> */}
    <StyledPardotButton buttonType="ModulePrimary" onClick={() => {modalRef.current.openModal()}}>Sign up</StyledPardotButton>
      <Modal ref={modalRef}>
        <div>
          <PardotForm config={JSON.stringify({
            "id": "newsletter-signup",
            "embedContext": "page",
            "embedStyle": { "maxWidth": "100%", "width": "380px" },
            "styleOverrides": ".suffix {color: white;}.form .submit_button{background-color: #D7EE8A; color: #000;}",
            "doGeolocation": true,
            "strings": { "button_text": "Sign up" },
            "formUrl": "	https://go.thoughtspot.com/l/710713/2023-11-01/b8p81",
            "successMessageHTML": "<p>Thanks for signing up!</p>",
            "sharedConfigs": "mode"
          })} heading={''}></PardotForm>
        </div>
      </Modal>
  </NewsletterCTA>
};
